import { Form } from '@base-ui/react/form';
import { ApplicationAnswers } from '@/components/settings/ApplicationAnswers';
import { IntegrationsSection } from '@/components/settings/IntegrationsSection';
import { ProfileSection } from '@/components/settings/ProfileSection';
import { ScheduleSection } from '@/components/settings/ScheduleSection';
import { ScoringSection } from '@/components/settings/ScoringSection';
import { ScrapersSection } from '@/components/settings/ScrapersSection';
import { SettingsDiscardDialog } from '@/components/settings/SettingsDiscardDialog';
import { SettingsHeader } from '@/components/settings/SettingsHeader';
import { SettingsSaveBar } from '@/components/settings/SettingsSaveBar';
import { ScrollPane } from '@/components/ui/ScrollPane';
import { Spinner } from '@/components/ui/Spinner';
import { useSettingsShell } from '@/providers/settings/SettingsContext';

export const Settings = () => {
  const {
    applyChanges,
    formErrors,
    getInputProps,
    getRootProps,
    isLoading,
    profile,
  } = useSettingsShell();

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm lg:text-base text-foreground-muted">
        No profile found. Complete onboarding first.
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col" {...getRootProps()}>
      <input {...getInputProps()} />
      <ScrollPane className="min-h-0 flex-1">
        <Form
          className="pt-8 w-full"
          errors={formErrors}
          onSubmit={(e) => {
            e.preventDefault();
            applyChanges();
          }}
        >
          <div className="flex flex-col gap-10 mx-auto max-w-5xl px-6">
            <SettingsHeader />
            <ScrapersSection />
            <ScoringSection />
            <ScheduleSection />
            <IntegrationsSection />
            <ProfileSection />
            <ApplicationAnswers />
          </div>
          <SettingsSaveBar />
        </Form>
      </ScrollPane>
      <SettingsDiscardDialog />
    </div>
  );
};
